module.exports = "/_next/static/images/Volume-9e8491a999c9635cdcce3440d0d6978b.gif";